import React, { useRef, useState } from 'react';
import { LogClick } from '../ClickStream';
import FeedbackModal from './FeedbackModal';
import FeedbackModalWrap from './FeedbackModalWrap';
import { CircleButton } from './FeedbackStyled';
import { getFeedbackPulse, setFeedbackPulse } from './SessionStorage';
import FeedbackButtonOpenContent from './components/FeedbackButtonOpenContent';
import { ReactComponent as Close } from './icons/close.svg';

const Feedback = () => {
  const [showModal, setShowModal] = useState(false);
  const [pulse, setPulse] = useState(getFeedbackPulse());
  const buttonRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <LogClick eventType="feedback_open" eventInfo={`Нажал открыть обратную связь`}>
        <CircleButton
          pulse={pulse}
          ref={buttonRef}
          width={!showModal ? 'revert' : undefined}
          onClick={() => {
            if (pulse) {
              setPulse(false);
              setFeedbackPulse(false);
            }
            setShowModal(!showModal);
          }}
          style={{ position: 'fixed', bottom: 28, right: 88, zIndex: 1005 }}
        >
          {showModal ? <Close /> : <FeedbackButtonOpenContent />}
        </CircleButton>
      </LogClick>
      {showModal && (
        <FeedbackModalWrap onClose={() => setShowModal(!true)}>
          <FeedbackModal target={buttonRef} />
        </FeedbackModalWrap>
      )}
    </>
  );
};

export default Feedback;
